"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <div
          style={{
            display: "flex",
            minHeight: "100vh",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
            fontFamily: "Arial, Helvetica, sans-serif",
          }}
        >
          <h2
            style={{
              marginBottom: "1rem",
              fontSize: "1.25rem",
              fontWeight: 600,
            }}
          >
            문제가 발생했습니다
          </h2>
          <p style={{ marginBottom: "1.5rem", color: "#666" }}>
            일시적인 오류가 발생했습니다. 다시 시도해주세요.
          </p>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "0.5rem",
              backgroundColor: "#000",
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
          >
            다시 시도
          </button>
        </div>
      </body>
    </html>
  );
}
